<template>
  <div>
    <b-container class="text-center">
      <img class="kuzzle-logo" src="../assets/images/kuzzle-iot.png" />
      <h1>Welcome to Kuzzle IoT Platform</h1>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'Home'
};
</script>

<style lang="sass">
.kuzzle-logo
  width: 50%
</style>
